import { FormLabel, Icon, IValidateError, Textinput } from "shared/index";
import React, { useState } from "react";
import styles from "./hidden-input-field.module.scss";

interface IHiddenInputFieldProps {
    value?: string;
    title?: string;
    className?: string;
    name: string;
    subLabel?: string;
    onChange: (value?: string) => void;
    disabled?: boolean;
    validate?: boolean;
    validateFunc?: (value: string) => IValidateError;
    onValidate?: (error: IValidateError) => void;
    triggerValidate?: number;

}

export const HiddenInputField: React.FC<IHiddenInputFieldProps> = React.memo(({
                                                                                  value,
                                                                                  className,
                                                                                  title,
                                                                                  name,
                                                                                  subLabel,
                                                                                  onChange,
                                                                                  disabled = false,
                                                                                  validateFunc,
                                                                                  validate,
                                                                                  onValidate,
                                                                                  triggerValidate
                                                                              }) => {
    const [hidden, setHidden] = useState(true);

    return <FormLabel title={title} className={className}>
        <Textinput size="m"
                   autoComplete="new-password"
                   name={name}
                   disabled={disabled}
                   validateFunc={validateFunc}
                   validate={validate}
                   onValidate={onValidate}
                   triggerValidate={triggerValidate}
                   type={hidden ? "password" : "text"}
                   iconRight={<Icon
                       className={styles.eyeIcon}
                       glyph={hidden ? "eyeOff" : "eye"}
                       onClick={() => setHidden((prevState) => !prevState)}/>}
                   value={value ? value : ""}
                   onChange={(e) => onChange(e.target.value ? e.target.value : undefined)}
                   view="outline"
                   placeholder={title}/>
        {subLabel && <div className={styles.subLabel}>{subLabel}</div>}
    </FormLabel>

});
